export function useOnClick() {
  return () => {
    window.alert('TODO:')
  }
}
